import styled from '@emotion/styled';

import { mobileToTabletQuery } from '../../utils/mediaqueries';

export const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  position: 'relative',
  width: '100%',

  [mobileToTabletQuery]: {
    userSelect: 'none',
  },
});

export const Content = styled.div({
  display: 'flex',
  flexDirection: 'column',
});
